export default "__VITE_ASSET__VbkrbOEV__"